import { apiService } from './apiService';

interface RegisterData {
    firstName: string;
    lastName: string;
    mobile: string;
    companyName: string;
    email: string;
    password: string;
    companyId: string;
}

const RegisterService = {
    register: async (data: RegisterData) => {
        return apiService.post('/users/register', data);
    }
};

export default RegisterService;
